import React, { useEffect, useState } from "react";
import "../../css/header.scss";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      className={`header ${
        scrolled ? "header--scrolled" : "header--transparent"
      }`}
    >
      <div className="header__inner">
        <div className="header__top">
          <div className="header__left">
            <button
              className="header__logo"
              onClick={() => {
                navigate("/");
                toTop();
              }}
              aria-label="Home"
            >
              <img alt="READYFOR" src="/head/main-jp.png" />
            </button>
          </div>

          <div className="header__right">
            <Link onClick={toTop} to="/donations" className="header__link">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="icon-red" />
              <span>プロジェクトをさがす</span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
